import Search from "components/global/Search";
import Sidebar from "components/global/sidebar";
import Slider from "components/user/dashboard/Slider";
import Navbar from "components/user/navbar";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


const UserDashboard = () => {
    const navigate = useNavigate();

    const seeAllHandler = (category , type) => {
        navigate(`/user/seller-list?category=${category}&type=${type}`);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="w-full pb-20">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl mt-24 lg:pr-20 md:pr-12 sm:pr-8 ">
                <div className="md:px-2 px-4">
                    <div className="light-shadow w-full py-4 px-4 rounded-lg ">
                        <Search />
                    </div>
                </div>
                <div className="flex flex-col gap-6 mt-4 md:px-0 px-2">
                    <div>
                        <Slider heading='See All Top Sellers' />
                        <div className='mt-8 flex items-center justify-center'>
                            <button className="btn-secondary py-3"
                            onClick={() => seeAllHandler('All Top Sellers' , 1) }
                            >
                                See all Top Sellers
                            </button>
                        </div>
                    </div>
                    <div>
                        <Slider heading='Low Budget' />
                        <div className='mt-8 flex items-center justify-center'>
                            <button className="btn-secondary py-3"
                            onClick={() => seeAllHandler('Low Budget Sellers' , 1) }
                            >
                                See all Low Budget
                            </button>
                        </div>
                    </div>
                    <div>
                        <Slider heading='Airport Screens' />
                        <div className='mt-8 flex items-center justify-center'>
                            <button className="btn-secondary py-3"
                            onClick={() => seeAllHandler('All Brand Promotion' , 1) }
                            >
                                See all Brand Promotion
                            </button>
                        </div>
                    </div>
                    <div>
                        <Slider heading='Railway Station Screens' />
                        <div className='mt-8 flex items-center justify-center'>
                            <button className="btn-secondary py-3"
                            onClick={() => seeAllHandler('All Crypto Sellers' , 1) }
                            >
                                See all Crypto Friendly
                            </button>
                        </div>
                    </div>
                    <div>
                        <Slider heading='Bus Stand Screens' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserDashboard;